import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { toggleLobbyVideoActive } from 'flow/actions/meeting-lobby-actions';
import MeetingLobbyDeviceButton from './MeetingLobbyDeviceButton';

/**
 * Turn the camera off and on before joining. Off covers both a deliberate
 * choice and a refused camera, for the same reason as the microphone: either
 * way there is no picture to send.
 */
const MeetingLobbyCameraButton = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const videoActive = useAppSelector((state) =>
        state.meeting.getIn(['lobby', 'videoActive']),
    );
    const videoAllowed = useAppSelector((state) =>
        state.meeting.getIn(['devices', 'videoAllowed']),
    );

    const cameraIsOn = videoActive && videoAllowed;

    return (
        <MeetingLobbyDeviceButton
            dataTestId="meeting-lobby-video-button"
            iconKey={cameraIsOn ? 'video_outlined' : 'videocam_off'}
            isOn={cameraIsOn}
            disabled={!videoAllowed}
            // See the mic button on why no shortcut is appended.
            tooltipLabel={i18next.t(
                cameraIsOn
                    ? 'videoconference.controlpanel.turn_camera_off'
                    : 'videoconference.controlpanel.turn_camera_on',
            )}
            onClick={() => dispatch(toggleLobbyVideoActive())}
        />
    );
};

export default MeetingLobbyCameraButton;
